<script>
  import { createEventDispatcher } from 'svelte'
  import { cloneDeep } from 'lodash'
  import Modal from './Modal.svelte'
  import LocationDetails from './LocationDetails.svelte'
  import ItemDetails from './ItemDetails.svelte'
  import ItemSelect from './ItemSelect.svelte'
  import {
    auth,
    currentLocation,
    locations,
    currentSheet,
    squareItems,
  } from './stores/root.js'
  import { saveItem } from './stores/inventory.js'

  const handleItemSelect = (item, variation) => {
    currentItem = item.value
    currentVariation = variation.value
  }

  const handleSave = async () => {
    saving = true

    try {
      const result = await saveItem({
        sheetId: $currentSheet.id,
        item: {
          id: currentItem.id || null,
          name: currentItem.name,
          squareId: currentItem.squareId,
          notes: currentItem.notes,
        },
        variation: currentVariation,
        details: details,
      })

      if (result.data.currentSheet) {
        currentSheet.set(result.data.currentSheet)
      }

      dispatch('close')

      saving = false
    } catch (error) {
      alert('There was an error saving the item.  Please refresh this page and try again.  If the problem persists, contact info@twinsistersmarket.com')
      saving = false
      return
    }
  }

  const resetDetails = () => {
    details.forEach((detail) => {
      detail.enabled = false
      detail.qtyStart = null
      // detail.donate = false
    })
  }

  const validateCurrentSelection = () => {
    const existingItem = $currentSheet.items.find(
      (item) =>
        item.squareId === currentItem.squareId &&
        item.variationSquareId === currentVariation.squareId
    )

    if (existingItem) {
      alert(
        `${existingItem.name}, ${existingItem.variationName} has already been added.  Please select a different item or type`
      )
    } else {
      showDetails = true
    }
  }

  const dispatch = createEventDispatcher()

  export let editItem = null

  let showDetails = false
  let currentItem = null
  let currentVariation = null
  let saving = false

  $: formValid =
    editItem ||
    (details.some((d) => d.enabled) &&
      details.every((d) => !d.enabled || (d.enabled && d.vendor)))

  const activeLocations = $currentLocation ? [$currentLocation] : $locations

  const details = activeLocations.map((location) => {
    let detail = {
      location,
      id: null,
      enabled: activeLocations.length === 1,
      qtyStart: null,
      donate: true,
      vendor: $auth.user.vendor ? $auth.user.vendor.id : null,
    }

    if (editItem) {
      const detailMatch = editItem.details.find(
        (detail) => detail.location === location.id
      )

      if (detailMatch) {
        detail.id = detailMatch.id
        detail.enabled = true
        detail.qtyStart = detailMatch.qtyStart
        detail.qtySold = detailMatch.qtySold
        detail.donate = detailMatch.donate
        detail.vendor = detailMatch.vendor ? detailMatch.vendor.id : null
      }
    }

    return detail
  })

  if (editItem && editItem.squareId && editItem.variationSquareId) {
    const item = cloneDeep(
      $squareItems.find((item) => item.value.squareId === editItem.squareId)
    )

    item.value.id = editItem.id
    item.value.notes = editItem.notes

    const variation = cloneDeep(
      item.value.variations.find(
        (variation) => variation.value.squareId === editItem.variationSquareId
      )
    )

    handleItemSelect(item, variation)

    showDetails = true
  } else if (editItem && $currentSheet.closed) {
    handleItemSelect({value: {name: editItem.name, notes: editItem.notes}}, {value: {name: editItem.variationName}})
    showDetails = true
  }
</script>

<Modal large on:close={() => dispatch('close')}>
  <div class="modal-header">
    <div class="fs-4 modal-title">
      {#if showDetails}
        {currentItem.name} - {currentVariation.name}
      {:else}
        Add Item
      {/if}
    </div>

    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
    />
  </div>

  <div class="modal-body">
    {#if showDetails && $currentSheet.closed == false}
    <ItemDetails
    price={currentVariation.price}
    unit={currentVariation.unit}
  />
    {/if}
    {#if showDetails}
      
      <div class="mt-4">
        <h5>Market Locations</h5>
        <!-- <div>Enable each market this item will be sold at.</div> -->
      </div>

      <div class="px-2">
        {#each details as detail}
          <LocationDetails bind:detail />
        {/each}
      </div>

      <div class="p-2">
        <!-- Text input for notes -->
        <div class="form-floating mb-3">
          <input
            type="text"
            class="form-control"
            id="notes"
            placeholder="Notes"
            bind:value={currentItem.notes}
          />
          <label for="notes">Notes</label>
        </div>
      </div>
    {:else}
      <ItemSelect handleSelect={handleItemSelect} />

      <div class="mt-4">
        <div class="fw-bold">Can't find what you're looking for?</div>
        <div>
          Email <a href="mailto:info@twinsistersmarket.com"
            >info@twinsistersmarket.com</a
          > if you would like to update the inventory or item details.
        </div>
      </div>
    {/if}
  </div>

  <div class="modal-footer">
    {#if showDetails}
      <button
        type="button"
        class="btn btn-link"
        disabled={saving}
        on:click={() => {
          showDetails = false
          resetDetails()
        }}>Back</button
      >

      <button
        type="button"
        class="btn btn-primary"
        disabled={!formValid || saving}
        on:click={handleSave}
      >
        {#if saving}
          <div
            class="spinner-border spinner-border-sm text-light"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        {:else}
          Save
        {/if}
      </button>
    {:else}
      <button
        type="button"
        class="btn btn-primary"
        disabled={!currentItem || !currentVariation}
        on:click={validateCurrentSelection}
      >
        Continue
      </button>
    {/if}
  </div>
</Modal>

<style>
  .btn-primary {
    min-width: 130px;
  }
</style>
